import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ClimaProgramService } from '~/api/services/climaProgram'
import Dialog from '~/components/Dialog'
import { Nullable } from '~/types'
import { handleErrors } from '~/utils/helpers'

interface Props {
  id: Nullable<string>
  onClose: () => void
  onSuccess: () => void
}

const CloseFeedPurchaseModal: React.FC<Props> = ({ id, onClose, onSuccess }) => {
  const { t } = useTranslation()

  const [isLoading, setIsLoading] = useState(false)

  async function handleCloseFeedPurchase() {
    setIsLoading(true)
    try {
      await ClimaProgramService.closeFeedPurchase(id)
      onSuccess()
      onClose()
    } catch (error) {
      handleErrors(error)
    }
    setIsLoading(false)
  }

  return <Dialog
    type='abort'
    textHeader={t('Completed')}
    handleSubmit={() => handleCloseFeedPurchase()}
    isDialogOpen={Boolean(id)}
    isLoading={isLoading}
    textClose={t('Abort')}
    textSubmit={t('Yes')}
    handleClose={onClose}
    textContent={t('Would you like to mark the feed purchase as complete?')}
  />
}
export default CloseFeedPurchaseModal